import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { PlayerSearchInput } from 'common/react/components/PlayerSearchInput';
import { setLeaderboardFilter } from 'common/store/modules/player-awards/leaderboard';

export const Search = ({ trackingComponentName }) => {
    const [query, setQuery] = useState('');
    const [debouncedQuery, setDebouncedQuery] = useState(query);

    const elementRef = useRef('');
    const lastTrackedQuery = useRef('');

    const dispatch = useDispatch();

    const onSearchSubmit = async (newQuery) => {
        dispatch(
            setLeaderboardFilter({
                query: newQuery
            })
        );
    };

    const onSearchClear = () => {
        onSearchSubmit('');
    };

    const handleElementChange = (element) => {
        elementRef.current = element;
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            const trimmedQuery = debouncedQuery.trim();
            setQuery(trimmedQuery);

            if (trimmedQuery.length > 2) {
                if (trimmedQuery !== lastTrackedQuery.current) {
                    PULSE.app.analytics.addSearchTracking(elementRef.current);
                    lastTrackedQuery.current = trimmedQuery;
                }
            } else {
                lastTrackedQuery.current = '';
            }
        }, 1000);
        return () => clearTimeout(timer);
    }, [debouncedQuery]);

    useEffect(() => {
        if (query !== '' && query.length > 2) {
            onSearchSubmit(query);
        } else {
            onSearchSubmit('');
        }
    }, [query]);

    return (
        <PlayerSearchInput
            setDebouncedQuery={setDebouncedQuery}
            onClear={onSearchClear}
            onElementChange={handleElementChange}
            trackingComponentName={trackingComponentName}
        />
    );
};

Search.propTypes = {
    trackingComponentName: PropTypes.string
};
